export const beforeItems = [
  "Your educational resources are spread across different files, courses, and personal notes.",
  "You spend time searching for assessment worksheets and documentation materials.",
  "You want a more consistent framework for reviewing relevant patient information.",
  "You need an organized way to study potential complications and clinical warning signs.",
  "Your documentation and follow-up resources are not always easy to locate.",
  "You want a practical reference library that supports your continuing professional education.",
];

export const afterItems = [
  "Your educational references are organized into six clearly defined volumes.",
  "You have structured worksheets to help organize relevant patient information.",
  "You can revisit clinical safety concepts through dedicated educational resources.",
  "You have templates to support consistent documentation.",
  "You can study hypothetical clinical cases using a structured review format.",
  "You have dedicated materials for organizing follow-up and professional reference information.",
];
